import { createSelector } from "@ngrx/store";

import * as fromRoot from "../../../router-store";
import * as fromFeature from "../reducers";
import * as fromAssignmentsStudents from "../reducers/assignments-students.reducer";
import * as selectorsHelperFn from "#helpers/selectors.helper";
import { PPAssignment as Assignment } from "cli-types";

// get student state
export const getAssignmentsStudentsState = createSelector(
    fromFeature.getCoursesModuleState,
    (state: fromFeature.CoursesState) => state.assignmentsStudents
);

// get student entities
export const getAssignmentsStudentsEntities = createSelector(
    getAssignmentsStudentsState,
    fromAssignmentsStudents.getCourseAssignmentsStudentsEntities
);

// get individual student
export const getAssignmentsSelectedStudent = createSelector(
    getAssignmentsStudentsEntities,
    fromRoot.getRouterState,
    (entities, router): Assignment | null => {
        return selectorsHelperFn.getSelectedEntity<Assignment>(
            entities,
            router,
            "studentId"
        );
    }
);

// convert Entities so view can consume
export const getCourseAssignmentsStudents = createSelector(
    getAssignmentsStudentsEntities,
    entities => {
        return Array.from(entities.values());
    }
);

export const getCourseAssignmentsStudentsLoaded = createSelector(
    getAssignmentsStudentsState,
    fromAssignmentsStudents.getCourseAssignmentsStudentsLoaded
);

export const getCourseAssignmentsStudentsLoading = createSelector(
    getAssignmentsStudentsState,
    fromAssignmentsStudents.getCourseAssignmentsStudentsLoading
);

export const getCourseAssignmentsStudentRawResponse = createSelector(
    getAssignmentsStudentsState,
    fromAssignmentsStudents.getCourseAssignmentsRawResponse
);

export const getCourseAssignmentsStudentPaginationParams = createSelector(
    getAssignmentsStudentsState,
    fromAssignmentsStudents.getCourseAssignmentsStudentsPaginationParams
);
